export enum AnnouncementJurisdictionScopeTypeKey {
  ALL = 'all',
  CANADA = 'canada',
  USA = 'usa',
  SELECT = 'select'
}
